import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=494c1dc2&scoped=true"
import script from "./InputError.vue?vue&type=script&lang=js"
export * from "./InputError.vue?vue&type=script&lang=js"
import style0 from "./InputError.vue?vue&type=style&index=0&id=494c1dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c1dc2",
  null
  
)

export default component.exports